import { Provider, Signal, computed } from "@angular/core";
import {
    ATOM_DATE_RANGE_FILTER_ERROR_MESSAGES,
    type AtomDateRangeFilterMessagesMap,
} from "@atomchat-io/ui-design-system";
import { translateObjectSignal } from "@jsverse/transloco";

const BASE_KEY_PATH = "global_dropdown.calendar_filter.errors";

/**
 * Localizes `atom-date-range-filter` validation copy (incomplete range, invalid
 * dates, min/max bounds). The DS defaults to English via
 * `ATOM_DATE_RANGE_FILTER_ERROR_MESSAGES`; this override follows the active
 * Transloco language like {@link provideAtomDateRangePresetLabels}.
 */
export const provideAtomDateRangeFilterErrorMessages = (): Provider => ({
    provide: ATOM_DATE_RANGE_FILTER_ERROR_MESSAGES,
    useFactory: (): Signal<AtomDateRangeFilterMessagesMap> => {
        const errors = translateObjectSignal(BASE_KEY_PATH) as Signal<
            Record<keyof AtomDateRangeFilterMessagesMap, string>
        >;
        return computed(() => errors());
    },
});
